import { authentication } from '@microsoft/teams-js';

export function getTeamsJwt(): Promise<string> {
	return authentication.getAuthToken();
}
